import { createAction } from 'redux-actions'

export const addFileUploads = createAction('ADD_FILE_UPLOADS')
export const updateFileUploads = createAction('UPDATE_FILE_UPLOADS')
export const clearFileUploads = createAction('CLEAR_FILE_UPLOADS')
export const removeFileUploads = createAction('REMOVE_FILE_UPLOADS')
export const cancelFileUploads = createAction('CANCEL_FILE_UPLOADS')
export const clearSuccessFileUploads = createAction('CLEAR_SUCCESS_FILE_UPLOADS')
